import { useCallback, useMemo, useSyncExternalStore } from 'react'
import { getCachedAnswer } from 'state/cache'
import { subscribeToCachedEntity } from 'state/entityCacheSubscriptions'

const EMPTY_SNAPSHOT = null

export default function useCachedAnswer(id: string | null | undefined) {
    const privateSnapshot = useMemo(
        () => (id === '__PRIVATE__' ? { id: '__PRIVATE__' } : null),
        [id],
    )
    const subscribe = useCallback(
        (listener: () => void) => subscribeToCachedEntity('answer', id, listener),
        [id],
    )
    const getSnapshot = useCallback(() => {
        if (!id) return EMPTY_SNAPSHOT
        if (privateSnapshot) return privateSnapshot
        return getCachedAnswer(id)
    }, [id, privateSnapshot])

    return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
